/** @jsx jsx */
import { jsx } from '@emotion/core';
import { RichText } from '@sitecore-jss/sitecore-jss-react';
import { get } from 'lodash';
import { React, Component } from 'react';
import { Icon } from '../../../ui/Icon';

import * as Styles from './index.styles';

export default class Card extends Component {
  render() {
    const { data } = this.props;

    const CTA1Link = get(data, 'Cta1Link', '');
    const CTA1Text = get(data, 'Cta1Text', '');
    const CTA2Link = get(data, 'Cta2Link', '');
    const CTA2Text = get(data, 'Cta2Text', '');

    const Intro = get(data, 'Intro', '');
    const ThemeColour = get(data, 'ThemeColour', '');
    const Title = get(data, 'Title', '');
    let IconSrc = get(data, 'Icon', '');

    //TODO :: remove this when final commit
    //if (IconSrc) {
    //const preUrl = 'http://regus.dev.local/';
    //IconSrc = preUrl + IconSrc;
    //}

    return (
      <div
        className="swiper-slide"
        css={[
          Styles.whatwedocardui,
          ThemeColour && Styles.setHeightlight(ThemeColour),
        ]}
      >
        {IconSrc && (
          <span>
            <img src={IconSrc} alt="icon" />
          </span>
        )}
        <RichText field={{ value: Title }} tag="h3" />
        {/* <h3>{data.title}</h3> */}
        <p>{Intro}</p>
        <div className="findoutlink">
          {CTA1Link && (
            <a href={CTA1Link}>
              <span>{CTA1Text}</span>
              <span>
                <Icon name="chevron-right" />
              </span>
            </a>
          )}

          {CTA2Link && (
            <a href={CTA2Link}>
              <span>{CTA2Text}</span>
              <span>
                <Icon name="chevron-right" />
              </span>
            </a>
          )}
        </div>
      </div>
    );
  }
}
